module.exports = __webpack_public_path__ + "img/top BT (3).21c0d618.png";